import { gql } from '@apollo/client';

export const GET_SCHEDULE_BY_TERM = gql`
  query GetScheduleByTerm(
    $filter: ScheduleFilterInput
    $page: Int
    $size: Int
  ) {
    product {
      schedules(filter: $filter, page: $page, size: $size) {
        totalCount
        pageInfo {
          hasNextPage
        }
        edges {
          node {
            id
            term {
              startedAt
              duration
              endedAt
            }
            saleTerm {
              startedAt
              endedAt
            }
            status
            booking {
              counts {
                total
                applied
                confirmed
                used
                absent
              }
            }
            product {
              title
              catchphrase
              kind
              status
              saleTerm {
                startedAt
                endedAt
              }
              frip {
                kind
                attachedToSchedule
                bookingConfirmationEnabled
                difficulty
                isIndoor
                isOutdoor
                locationsOfVenue {
                  id
                  label
                  address
                  geoPoint {
                    latitude
                    longitude
                  }
                  overseas
                  location {
                    id
                    name
                  }
                }
                locationOfGathering {
                  id
                  label
                  address
                  geoPoint {
                    latitude
                    longitude
                  }
                  overseas
                  location {
                    id
                    name
                  }
                }
                plans {
                  id
                  appliedAllItems
                  name
                  minimumQuota
                  preparatoryPeriod
                  quota
                  overNight
                  term {
                    startedAt
                    endedAt
                  }
                  targetItems {
                    id
                  }
                  times {
                    starting {
                      hour
                      minute
                    }
                    duration
                  }
                  weeks
                }
                curriculum {
                  kind
                  sections {
                    id
                    title
                    etc
                    status
                    items {
                      id
                      term {
                        startingTime {
                          hour
                          minute
                        }
                        endingTime {
                          hour
                          minute
                        }
                      }
                      duration
                      textTime
                      content
                    }
                  }
                  style
                }
                exclusions
                inclusions
                stuffsToPrepare
                daysOfExpiration
                recommendedAge
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_BOOKING_LIST = gql`
  query GetBookingListByFilter(
    $filter: BookingFilterInput
    $page: Int
    $size: Int
  ) {
    booking {
      bookings(filter: $filter, page: $page, size: $size) {
        totalCount
        edges {
          node {
            id
            status
            tickets {
              id
              confirmedAt
              usedAt
              absentAt
              scheduleTerm {
                startedAt
              }
              status
            }
            customer {
              id
              nickname
              mobileNumber
              gender
              profileImage {
                uri
              }
            }
            order {
              id
              transactions {
                id
                type
                firm
                firmedAt
                status
                actionStatus
                order {
                  id
                }
                items {
                  id
                }
              }
              status
              items {
                canceled
                id
                dependedItems {
                  id
                  units {
                    indexNo
                  }
                }
              }
            }
            info {
              id
              name
              options {
                id
                name
              }
              product {
                id
                title
                content {
                  thumbnail
                }
              }
              host {
                id
                name
              }
              origin {
                inquiryTemplate {
                  inquiries {
                    id
                    inputKind
                    inputPattern
                    items {
                      id
                      label
                      value
                    }
                    required
                    status
                    title
                  }
                  name
                }
                type
                product {
                  saleTerm {
                    startedAt
                    endedAt
                  }
                }
                saleTerm {
                  startedAt
                  endedAt
                }
              }
              ticketCount
            }
            schedule {
              id
              term {
                startedAt
                endedAt
                duration
              }
            }
            items {
              booking {
                status
                id
              }
              id
              indexNo
              replies {
                title
                answer
                selections {
                  label
                }
              }
              counts {
                total
                applied
                confirmed
                used
                absent
              }
              tickets {
                id
                absentAt
                canceledAt
                availableActions
                scheduleTerm {
                  startedAt
                  endedAt
                  duration
                }
                confirmedAt
                usedAt
                status
                sequence
                bookingItem {
                  indexNo
                  booking {
                    id
                    customer {
                      id
                      nickname
                      mobileNumber
                      gender
                    }
                    info {
                      id
                      name
                      options {
                        id
                        name
                      }
                      product {
                        id
                        title
                      }
                      host {
                        id
                        name
                      }
                      origin {
                        type
                        product {
                          saleTerm {
                            startedAt
                            endedAt
                          }
                        }
                        saleTerm {
                          startedAt
                          endedAt
                        }
                        inquiryTemplate {
                          inquiries {
                            title
                            items {
                              label
                              value
                            }
                          }
                        }
                      }
                      ticketCount
                    }
                    schedule {
                      id
                      term {
                        startedAt
                        endedAt
                        duration
                      }
                    }
                  }
                }
              }
            }
            purchaseCount
            counts {
              total
              applied
              confirmed
              used
              absent
            }
          }
        }
        pageInfo {
          hasNextPage
        }
      }
    }
  }
`;

export const GET_BOOKING_TICKETS = gql`
  query GetBookingTickets($filter: TicketFilterInput, $page: Int, $size: Int) {
    booking {
      tickets(filter: $filter, page: $page, size: $size) {
        totalCount
        pageInfo {
          hasNextPage
        }
        edges {
          node {
            id
            absentAt
            canceledAt
            availableActions
            scheduleTerm {
              startedAt
              endedAt
              duration
            }
            confirmedAt
            usedAt
            status
            sequence
            bookingItem {
              counts {
                total
                applied
                confirmed
                used
                absent
              }
              booking {
                customer {
                  id
                }
                id
                status
                purchaseCount
                customer {
                  id
                  nickname
                  mobileNumber
                  gender
                }
                info {
                  id
                  name
                  options {
                    id
                    name
                  }
                  product {
                    id
                    title
                  }
                  host {
                    id
                    name
                  }
                  origin {
                    type
                    product {
                      saleTerm {
                        startedAt
                        endedAt
                      }
                      frip {
                        attachedToSchedule
                      }
                    }
                    saleTerm {
                      startedAt
                      endedAt
                    }
                    inquiryTemplate {
                      inquiries {
                        title
                        items {
                          label
                          value
                        }
                      }
                    }
                  }
                  ticketCount
                }
                schedule {
                  id
                  term {
                    startedAt
                    endedAt
                    duration
                  }
                }
                order {
                  id
                  items {
                    units(includeCancel: true) {
                      id
                      indexNo
                      replies {
                        id
                        indexNo
                        title
                        answer
                        selections {
                          value
                          label
                        }
                      }
                      status
                    }
                  }
                  transactions {
                    firmedAt
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/* 목록보기 쿼리 */
export const GET_LIST_VIEW_TICKET_LIST = gql`
  query GetTicketSchedules($page: Int, $size: Int, $filter: TicketFilterInput) {
    booking {
      tickets(page: $page, size: $size, filter: $filter) {
        totalCount
        edges {
          node {
            id
            status
            bookingItem {
              counts {
                absent
                applied
                confirmed
                total
                used
              }
              booking {
                id
                schedule {
                  allSalesCount {
                    sale
                  }
                  counts {
                    sale
                  }
                  id
                  items {
                    minimumQuota
                    counts {
                      sale
                    }
                    status
                  }
                  status
                  minimumQuota
                  term {
                    startedAt
                    endedAt
                  }
                  saleTerm {
                    endedAt
                  }
                  product {
                    inventoryTargetType
                    title
                    id
                    headerContents {
                      content {
                        thumbnail
                      }
                    }
                  }
                }
                info {
                  product {
                    id
                    title
                    content {
                      thumbnail
                    }
                  }
                }
              }
            }
            scheduleTerm {
              startedAt
              endedAt
            }
          }
        }
        pageInfo {
          hasNextPage
        }
      }
    }
  }
`;

/* 일정 조율형 */
export const GET_UNFIXED_SCHEDULE_TICKET_LIST = gql`
  query GetTicketSchedules($page: Int, $size: Int, $filter: TicketFilterInput) {
    booking {
      tickets(page: $page, size: $size, filter: $filter) {
        totalCount
        edges {
          node {
            id
            status
            bookingItem {
              counts {
                absent
                applied
                confirmed
                total
                used
              }
              booking {
                info {
                  product {
                    id
                    title
                    content {
                      thumbnail
                    }
                  }
                }
              }
            }
            # 일정 조율형의 경우, 진행시간
            scheduleTerm {
              startedAt
              endedAt
            }
          }
        }
        pageInfo {
          hasNextPage
        }
      }
    }
  }
`;

/* 일정 지정형 */
export const GET_FIXED_SCHEDULE_TICKET_LIST = gql`
  query GetScheduleByTerm(
    $filter: ScheduleFilterInput
    $page: Int
    $size: Int
  ) {
    product {
      schedules(filter: $filter, page: $page, size: $size) {
        totalCount
        pageInfo {
          hasNextPage
        }
        edges {
          node {
            counts {
              sale
              quota
            }
            allSalesCount {
              sale
            }
            id
            items {
              minimumQuota
              counts {
                sale
                quota
              }
              name
              status
            }
            status
            minimumQuota
            term {
              startedAt
              endedAt
            }
            saleTerm {
              endedAt
            }
            product {
              inventoryTargetType
              title
              id
              headerContents {
                content {
                  thumbnail
                }
              }
            }
          }
        }
      }
    }
  }
`;

/* 상품 필터 리스트 조회 */
export const GET_PRODUCT_FILTER_LIST = gql`
  query ($filter: ProductFilterInput) {
    productContainer {
      products(filter: $filter) {
        edges {
          node {
            id
            headerContents {
              content {
                thumbnail
              }
            }
            title
          }
        }
      }
    }
  }
`;

/* 일정 취소 요청  */
export const CANCEL_SCHEDULE = gql`
  mutation CancelSchedule(
    $scheduleId: ID!
    $param: ScheduleCancellationParamInput!
  ) {
    cancelSchedule(id: $scheduleId, param: $param) {
      id
      status
    }
  }
`;

/* 일정 조율형 전체갯수 조회 */
export const GET_UNFIXED_SCHEDULE_TICKET_COUNTS = gql`
  query GetTicketSchedules($page: Int, $size: Int, $filter: TicketFilterInput) {
    booking {
      tickets(page: $page, size: $size, filter: $filter) {
        totalCount
        pageInfo {
          hasNextPage
        }
      }
    }
  }
`;

/* 예약 엑셀 id 추출 */
export const REQUEST_BOOKING_EXCEL_EXPORT = gql`
  mutation RequestBookingExcelExport($filter: BookingFilterInput!) {
    requestBookingExcelExport(filter: $filter) {
      id
    }
  }
`;

/* 예약 엑셀 조회 */
export const BOOKING_EXCEL_REQUEST = gql`
  query BookingExcelRequest($id: ID!) {
    booking {
      bookingExportRequest(id: $id) {
        id
        status
        url
      }
    }
  }
`;
